export default __webpack_public_path__ + "build/98587c8175512a62d96f5265a48da472.png";